var _rect, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedLockIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#ECF1F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6654 36.667H49.9987V31.667C49.9987 26.167 45.4987 21.667 39.9987 21.667C34.4987 21.667 29.9987 26.167 29.9987 31.667V36.667H28.332C25.4987 36.667 23.332 38.8337 23.332 41.667V53.3337C23.332 56.167 25.4987 58.3337 28.332 58.3337H51.6654C54.4987 58.3337 56.6654 56.167 56.6654 53.3337V41.667C56.6654 38.8337 54.4987 36.667 51.6654 36.667ZM33.332 31.667C33.332 28.0003 36.332 25.0003 39.9987 25.0003C43.6654 25.0003 46.6654 28.0003 46.6654 31.667V36.667H33.332V31.667ZM51.6654 55.0003C52.6654 55.0003 53.332 54.3337 53.332 53.3337V41.667C53.332 40.667 52.6654 40.0003 51.6654 40.0003H28.332C27.332 40.0003 26.6654 40.667 26.6654 41.667V53.3337C26.6654 54.3337 27.332 55.0003 28.332 55.0003H51.6654Z",
    fill: "#D95945"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_28512_27342",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 21,
    width: 34,
    height: 38
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6654 36.667H49.9987V31.667C49.9987 26.167 45.4987 21.667 39.9987 21.667C34.4987 21.667 29.9987 26.167 29.9987 31.667V36.667H28.332C25.4987 36.667 23.332 38.8337 23.332 41.667V53.3337C23.332 56.167 25.4987 58.3337 28.332 58.3337H51.6654C54.4987 58.3337 56.6654 56.167 56.6654 53.3337V41.667C56.6654 38.8337 54.4987 36.667 51.6654 36.667ZM33.332 31.667C33.332 28.0003 36.332 25.0003 39.9987 25.0003C43.6654 25.0003 46.6654 28.0003 46.6654 31.667V36.667H33.332V31.667ZM51.6654 55.0003C52.6654 55.0003 53.332 54.3337 53.332 53.3337V41.667C53.332 40.667 52.6654 40.0003 51.6654 40.0003H28.332C27.332 40.0003 26.6654 40.667 26.6654 41.667V53.3337C26.6654 54.3337 27.332 55.0003 28.332 55.0003H51.6654Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_28512_27342)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 20H60V60H20V20Z",
    fill: "#D95945"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedLockIcon);
export default __webpack_public_path__ + "static/media/RedLockIcon.b64a0333112d7a021074ddcb4a637d68.svg";
export { ForwardRef as ReactComponent };